import axios from "axios";
import store from "../store/store";
import { logout } from "../store/authSlice";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  //headers: {
    //"Content-Type": "application/json",
  //},

});

api.interceptors.request.use(
(config) => {

const token = store.getState().auth.token;

if (token) {
config.headers.Authorization = `Bearer ${token}`;
}

return config;

},
(error) => Promise.reject(error)
);

api.interceptors.response.use(
(response) => response,
(error) => {

if (error.response?.status === 401) {
store.dispatch(logout());
window.location.href = "/authentication-portal";
}

return Promise.reject(error);

}
);

export default api;